import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {TimeUnit} from "../../../stem-core/time/Duration";
import {Money} from "../../../stem-core/localization/Money.js";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {FileResource} from "./FileResourceStore";
import {Merchant} from "../MerchantStore";
import {Currency} from "../../../stem-core/localization/CurrencyStore";


@globalStore
export class MerchantPayout extends BaseStore("MerchantPayout") {
    @field("Merchant") merchant: Merchant;
    @field("Currency") currency: Currency;
    @field(Money) paidAmount: Money;
    @field(Date) createdAt: Date;
    @field(Date) lastPaymentDate: any;
    @field(FileResource) pdfReport: FileResource;
    @field(FileResource) paymentsReport: FileResource;
    @field(FileResource) accountingReport: FileResource;
    @field(FileResource) zipArchive: FileResource;

    getName(): string {
        const {lastPaymentDate} = this;
        const period = lastPaymentDate.subtract(TimeUnit.DAY).format("YYYY-MM");
        return `${period} Payout`;
    }
}

export async function apiAdminGenerateStripeReport(): Promise<any> {
    const response = await apiClient.post("/admin/payouts/generate_stripe_report/");
    return MerchantPayout.load(response);
}

export async function apiAdminGetPayoutMonthSummaryReport(): Promise<any> {
    const response = await apiClient.post("/admin/payouts/get_monthly_report/");
    return MerchantPayout.load(response);
}

export async function apiAdminGeneratePayouts(): Promise<any> {
    const response = await apiClient.post("/admin/payouts/generate_monthly_report/");
    return MerchantPayout.load(response);
}

export async function apiAdminApprovePayout(payoutId: string): Promise<any> {
    return await apiClient.post("/admin/payouts/approve/", {payoutId})
}
